import React from 'react';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { MachineUpdateContent } from './MachineUpdateContent';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';
import RouterUtils from '../../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../../shared/routing/Routes';

export class MachineUpdateScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_DETAIL,
            Breadcrumbs.MACHINES_EMPTY,
            Breadcrumbs.MY_OUTSOURCES_MACHINES_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;
        const { machineId } = this.props.match.params;

        return (
            <PsPage title={I18nUtils.tr('TR_MAQUINA_DE_MI_SUBCONTRATA')} breadcrumbs={breadcrumbs}>
                <MachineUpdateContent
                    id={Number(machineId)}
                    appendBreadcrumb={this.appendBreadcrumb}
                />
            </PsPage>
        );
    }

    appendBreadcrumb = (machine) => {
        const { location, match } = this.props;
        const { outsourceId } = match.params;

        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_OUTSOURCES_DETAIL.id,
            url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DETAIL, { id: outsourceId }),
            description: machine.companyDescription(),
        });

        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_OUTSOURCES_MACHINES_DETAIL.id,
            url: location.pathname,
            description: machine.shortDescription(),
        });

        this.setState({
            breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
        });
    };
}

MachineUpdateScreen.propTypes = {};

MachineUpdateScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/form/update/MachineUpdateScreen.jsx